import { render, staticRenderFns } from "./Atendimento.vue?vue&type=template&id=a4cea94a&scoped=true"
import script from "./Atendimento.vue?vue&type=script&lang=js"
export * from "./Atendimento.vue?vue&type=script&lang=js"
import style0 from "./Atendimento.vue?vue&type=style&index=0&id=a4cea94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cea94a",
  null
  
)

export default component.exports